import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from '../auth';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private navigationStackKey = 'navigationStack';
  private appliedFilters = 'appliedFilters';
  private defaultRoot = 'defaultRoot';
  private navigationStack = new BehaviorSubject<any[]>([]);

  constructor(private router: Router, private authService: AuthService) {
    // Load navigationStack from localStorage on initialization
    const storedNavigationStack = localStorage.getItem(this.navigationStackKey);
    if (storedNavigationStack) {
      this.navigationStack.next(JSON.parse(storedNavigationStack));
    }
  }

  getCurrentURL(): boolean {
    const currentRoute = this.router.url;
    if (
      (currentRoute.includes('/patients/edit') ||
        currentRoute.includes('/contacts/edit') ||
        currentRoute.includes('/contacts/add') ||
        currentRoute.includes('/patients/add')) &&
      this.authService.getChange() &&
      !window.confirm('Changes you made may not be saved.')
    ) {
      return null;
    }
    // this.authService.setChanged(false);
    const currentParams: any = new URLSearchParams(
      this.router.routerState.snapshot.root.queryParams,
    );
    const urlWithoutFilters = currentRoute.split('?')[0];
    const updatedNavigationStack = [
      ...this.navigationStack.value,
      { url: urlWithoutFilters, currentParams, filters: '' },
    ];
    this.navigationStack.next(updatedNavigationStack);
    this.saveNavigationStackToLocalStorage(updatedNavigationStack);
    return true;
  }

  navigateTo(route: string, queryParams?: any): void {
    if (this.getCurrentURL()) {
      this.refreshFiltersOnLocalStorage();
      const queryParamsString = queryParams
        ? '?' + new URLSearchParams(queryParams).toString()
        : '';
      const navigationUrl = route + queryParamsString;
      this.router.navigateByUrl(navigationUrl);
    }
  }

  goBack(): void {
    const currentRoute = this.router.url;
    if (
      (currentRoute.includes('/patients/edit') ||
        currentRoute.includes('/contacts/edit') ||
        currentRoute.includes('/contacts/add') ||
        currentRoute.includes('/patients/add')) &&
      this.authService.getChange() &&
      !window.confirm('Changes you made may not be saved.')
    ) {
      return;
    }
    this.authService.setChanged(false);
    const navigationStack = this.navigationStack.value;
    if (navigationStack.length > 0) {
      const previousRoute = navigationStack.pop();
      const previousURL = previousRoute.url;
      localStorage.setItem(this.appliedFilters, JSON.stringify(previousRoute.filters));
      const previousParams = previousRoute.currentParams;
      const newUrl = previousURL + '?' + previousParams.toString();
      this.navigationStack.next([...navigationStack]);
      this.saveNavigationStackToLocalStorage(navigationStack);
      this.router.navigateByUrl(newUrl);
      return;
    }
    const defaultRoot = localStorage.getItem(this.defaultRoot);
    if (defaultRoot) this.router.navigateByUrl(defaultRoot);
  }

  updateURLWithFiltersOnList(filters): void {
    const lastElement = this.navigationStack.value.pop();
    if (lastElement) {
      lastElement.filters = filters;
      const updatedNavigationStack = [...this.navigationStack.value, lastElement];
      this.navigationStack.next(updatedNavigationStack);
      this.saveNavigationStackToLocalStorage(updatedNavigationStack);
    }
  }
  private saveNavigationStackToLocalStorage(navigationStack: any[]): void {
    localStorage.setItem(this.navigationStackKey, JSON.stringify(navigationStack));
  }
  refreshFiltersOnLocalStorage(): void {
    localStorage.removeItem(this.appliedFilters);
  }
  emptyNavigationStack(): void {
    this.navigationStack.next([]);
    localStorage.removeItem(this.navigationStackKey);
    localStorage.removeItem(this.appliedFilters);
    localStorage.removeItem(this.defaultRoot);
  }
  getFilters() {
    return JSON.parse(localStorage.getItem('appliedFilters'));
  }
  setDefaultRoot(key) {
    localStorage.setItem(this.defaultRoot, key);
  }
}
